import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PrProductUnitNameService extends ApiService {

    index(params: any): Observable<any> {
        return super.get('/pr-product-unit-names', params);
    }

    select(params: any = {}) {
        return super.get(`/pr-product-unit-names/select`, params);
    }

    store(body: any) {
        return super.post(`/pr-product-unit-names`, body);
    }

    edit(prProductUnitNameId: number) {
        return super.get(`/pr-product-unit-names/${prProductUnitNameId}/edit`);
    }

    update(prProductUnitNameId: number, body: any) {
        return super.put(`/pr-product-unit-names/${prProductUnitNameId}`, body);
    }

    destroy(prProductUnitNameId: number) {
        return super.delete(`/pr-product-unit-names/${prProductUnitNameId}`);
    }
}
